import { render, staticRenderFns } from "./buyCarItem.vue?vue&type=template&id=53ee030e&scoped=true&"
import script from "./buyCarItem.vue?vue&type=script&lang=js&"
export * from "./buyCarItem.vue?vue&type=script&lang=js&"
import style0 from "./buyCarItem.vue?vue&type=style&index=0&id=53ee030e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ee030e",
  null
  
)

export default component.exports